export enum PolicyTab {
  RULES = 'RULES',
  GROUPS = 'GROUPS',
  ACTIONS = 'ACTIONS',
}
